<template>
  <div class="">
    
    <!-- 查询表单 -->
    <div>
      <el-form ref="qu o te Form" :model="quoteForm" label-width="80px">
        <el-row :gutter="20">
          <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
            <el-form-item label="商户">
             <el-input clearable v-model="quoteForm.merchantLike"  placeholder="请输入商户名称或ID"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
            <el-button type="primary" @click="getQuoteConfigList">查询</el-button>
            <el-button type="primary" @click="addQuoteConfig">添加</el-button>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div style="margin-top: 20px;">
            <!-- 表格 -->
       <el-table
        :data="tableData"
        border
        style="width: 100%">
          <el-table-column
            prop="id"
            label="序号">
          </el-table-column>
          <el-table-column
            prop="merchantName"
            label="使用渠道">
          </el-table-column>
          <el-table-column
            label="服务时间">
            <template slot-scope="scope">
             {{
              $moment(scope.row.manualReviewStart).format('HH:mm')
            }}-{{$moment(scope.row.manualReviewEnd).format('HH:mm') }} 
          </template>
          </el-table-column>

          <el-table-column
            prop="manualReviewWait"
            label="人工审单等待时间(秒)">
          </el-table-column>
          <el-table-column
            prop="manualReviewAmount"
            label="免人工审核金额">
          </el-table-column>
          <!-- <el-table-column
            prop="biddingLimitValue"
            label="非默认回收商中标需比默认回收商高">
          </el-table-column> -->
          <el-table-column
            prop="status"
            label="账号状态">
            <template slot-scope="scope">
              <span v-if="scope.row.status === 1">已启用</span>
              <span v-else>已禁用</span>
            </template>
          </el-table-column>
          <!-- <el-table-column
            prop="enableDefaultPriceStatus"
            label="是否允许无默认回收商出价">
            <template slot-scope="scope">
              <span v-if="scope.row.enableDefaultPriceStatus === 0">否</span>
              <span v-else>是</span>
            </template>
          </el-table-column> -->
              <el-table-column
            prop="systemPriceWaitTime"
            label="系统价格出价开关">
            <template slot-scope="scope">
              <span v-if="scope.row.systemPriceWaitTime === 0">关闭</span>
              <span v-else>启用</span>
            </template>
          </el-table-column>
          <el-table-column
            label="操作">
              <template slot-scope="scope">
                <el-button @click="editorQuoteConfig(scope.row)" type="text" size="small">编辑</el-button>
                <el-button @click="switchQuoteConfigStatus(scope.row.id,1)" type="text" size="small" v-if="scope.row.status === 0">开启</el-button>
                <el-button @click="switchQuoteConfigStatus(scope.row.id,0)" type="text" size="small" style="color: red;" v-else>关闭</el-button>
                <el-button @click="deleteQuoteConfig(scope.row.id)" type="text" size="small" style="color: gray;" v-if="scope.row.id!=1">删除</el-button>
              </template>
          </el-table-column>
      </el-table>
      

      <!-- 分页 -->
      <el-pagination style="margin-top: 20px;"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 40, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="tableTotal">
      </el-pagination>
    </div>

   <!-- 修改或新建城市经理对话框 -->
   <el-dialog  :title="
        dlgType === 'change'
          ? '编辑审单配置'
          : '新建审单配置'
      " :visible.sync="isDlg" width="700px" >
      <div style="margin: 20px;">
        <div>
          <el-form
              ref="editQuoteForm"
              :model="editQuoteForm"
              :rules="editorFormRules"
              label-width="180px"
          >
          <el-form-item label="商户: " prop="merchantId" v-if="editQuoteForm.id!=1">
              <el-select clearable
                v-model="editQuoteForm.merchantId"
                filterable
                remote
                placeholder="请输入关键词"
                reserve-keyword
                :loading="loading">
                <el-option
                  v-for="item in merchatOptions"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="服务时间">
              <el-time-picker
                  is-range
                  v-model="editQuoteForm.manualReview"
                  format="HH:mm"
                  value-format="yyyy-MM-dd HH:mm"
                  range-separator="至"
                  start-placeholder="开始时间"
                  end-placeholder="结束时间"
                  placeholder="选择时间范围"
              >
              </el-time-picker>
            </el-form-item>
            <el-form-item label="人工审单等待时间" prop="manualReviewWait">
              <el-input clearable v-model="editQuoteForm.manualReviewWait"
              >
                <template slot="append">秒</template>
              </el-input
              >
            </el-form-item>
            <el-form-item label="免人审金额: " prop="manualReviewAmount">
              <el-input clearable v-model="editQuoteForm.manualReviewAmount"
              >
                <template slot="append">元</template>
              </el-input
              >
            </el-form-item>
            <!-- <el-form-item label="非默认回收商中标需比默认回收商高: " prop="biddingLimitValue">
              <el-input clearable v-model="editQuoteForm.biddingLimitValue"
              >
                <template slot="append">元</template>
              </el-input
              >
            </el-form-item> -->
            <el-form-item label="系统价格出价开关" prop="systemPriceWaitTime">
              <el-radio v-model="editQuoteForm.systemPriceWaitTime" :label="0" >关闭</el-radio>
              <el-radio v-model="editQuoteForm.systemPriceWaitTime" :label="1">启用</el-radio>
            </el-form-item>
            <!-- <el-form-item label="是否允许无默认回收商出价" prop="enableDefaultPriceStatus">
              <el-radio v-model="editQuoteForm.enableDefaultPriceStatus" :label="0" >否</el-radio>
              <el-radio v-model="editQuoteForm.enableDefaultPriceStatus" :label="1">是</el-radio>
            </el-form-item> -->
          </el-form>
        </div>
        <div style="text-align: center;">
          <el-button
              type="primary"
              style="margin: 30px 20px;"
              @click="submitEditor"
          >确定
          </el-button
          >
          <el-button style="margin: 10px 20px;" @click="closeEditorDlg"
          >暂不
          </el-button
          >
        </div>
      </div>
    </el-dialog>

  </div>
</template>

<script>
export default {
  components:{},
  props:{},
  data(){
    return {
      // 查询数据
      quoteForm: {
        merchantLike: null
      },
      loading: false,

      // 表格数据
      tableTotal: 0,
      tableData: [],
      pageSize: 10,
      currentPage: 1,
       // 商户选择
       merchatOptions: [],

      // 新建编辑对话框数据,
      queryGradeList:[],
      queryPadGradeList:[],

      isDlg: false,
      editQuoteForm: {
        id: null,
        manualReviewStart: "",
        manualReviewEnd: "",
        systemQuotationStart: "",
        systemQuotationEnd: "",
        manualReview: [],
        systemQuotation: [],
        enableDefaultPriceStatus:0,
        systemPriceWaitTime:0
      },

      editorFormRules: {
        merchantId: [
          { required: true, message: '请选择商户', trigger: 'change' },
        ],
        phone: [
          { required: true, message: '请输入电话', trigger: 'change' },
        ],
        password: [
          { required: true, message: '请输入账号密码', trigger: 'change' },
        ],
      },

      dlgType: 'change'
      
    }
  },
  watch:{},
  computed:{},
  methods:{
       //等级
    getGradeList() {
      let self = this;
        this.$api
            .getValidModelGrade({
              categoryId: 6099,
            })
            .then((res) => {
              self.queryGradeList = res.data || [];
            });
        this.$api
            .getValidModelGrade({
              categoryId: 10391,
            })
            .then((res) => {
              self.queryPadGradeList = res.data || [];
            });
    },
     // 请求商户列表
     getMerchantList(param) {
      let self = this;
      self.$api.getMerchantList({
        merchantLike: param,
        page: 1,
        size: 100000,
      }).then(res => {
        if(res.code === 200) {
          self.merchatOptions = res.data.records
        }
      
      })
    },
        //删除用户
    deleteQuoteConfig(id){
      let self = this
      self.$confirm('是否删除').then(() => {
         self.$api.deleteQuoteConfig({id:id}).then(res=>{
           if(res.code === 200) {
            this.$message({
              message: '删除成功',
              type: 'success'
            });
             this.getQuoteConfigList()
          }
      })
      })
    },
      // 分页函数
    handleSizeChange(val) {
      this.pageSize = val;
      // 每次调整pagesize后，跳回第一页，保证有数据及请求不会报错
      this.handleCurrentChange(1)
    },
    handleCurrentChange(val) {
      this.currentPage = val

      // 重新请求订单数据
      this.getQuoteConfigList()
    }, 
    closeEditorDlg() {
      this.isDlg = false;
    },

    // 获取订单数据
    getQuoteConfigList() {
      let self  = this;
      self.$api.quoteConfigPage({
        page: self.currentPage,
        size: self.pageSize,
        merchantLike: self.quoteForm.merchantLike
      }).then(res => {
        console.log(res)
        self.tableData = res.data.records || []
        self.tableTotal = res.data.total
      })
    },

    // 添加城市经理
    addQuoteConfig() {
      this.dlgType = 'new'
      this.editQuoteForm = {
        id: null,
        manualReviewStart: "",
        manualReviewEnd: "",
        systemQuotationStart: "",
        systemQuotationEnd: "",
        manualReview: ["",""],
        systemQuotation: [],
        enableDefaultPriceStatus:0,
        systemPriceWaitTime:0
      },
       this.$nextTick(()=>{
          this.$refs['editQuoteForm'].clearValidate()
      })
      this.isDlg = true
    },

    // 修改城市经理
    editorQuoteConfig(row) { 
      this.dlgType = 'change'
      this.editQuoteForm = row
      this.$set(this.editQuoteForm, "manualReview", [this.editQuoteForm.manualReviewStart, this.editQuoteForm.manualReviewEnd]);
      this.isDlg = true
    },

    // 提交编辑（新建或者修改）
    submitEditor() {
      let self = this;
      self.editQuoteForm.manualReviewStart = self.$moment(self.editQuoteForm.manualReview[0]).format('YYYY-MM-DD HH:mm:ss')
      self.editQuoteForm.manualReviewEnd = self.$moment(self.editQuoteForm.manualReview[1]).format('YYYY-MM-DD HH:mm:ss')
      this.$refs['editQuoteForm'].validate((valid) => {
        if (valid) {
          if(self.dlgType === 'change') {
            self.$api.updateQuoteConfig(self.editQuoteForm).then(res => {
              if(res.code === 200) {
                this.$message({
                  message: '修改成功',
                  type: 'success'
                });
                this.getQuoteConfigList()
                this.closeEditorDlg()
              }
            })
          } else {
            self.$api.saveQuoteConfig(self.editQuoteForm).then(res => {
              if(res.code === 200) {
                this.$message({
                  message: '添加成功',
                  type: 'success'
                });
                this.getQuoteConfigList()
                this.closeEditorDlg()
              }
            })
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
      
    },


    // 开启或禁用
    switchQuoteConfigStatus(id,status) {
      this.$api.updateQuoteConfig({id:id,status:status}).then(res => {
        this.$message({
          message: '更新成功',
          type: 'success'
        });
        if(res.code === 200) {
          this.getQuoteConfigList()
        }
      })
    }

  },
  created(){},
  mounted(){
    let self = this;
    self.getQuoteConfigList()
    self.getMerchantList()
  }
}
</script>
<style lang="less" scoped>
</style>